"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("@/api/common.js");
var _gift_card = require("@/api/community/gift_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardAssignTaskConfigPane',
  components: {},
  props: {
    fnId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      memberLabel: '',
      keywords: '',
      memberLabels: [],
      // 会员标签列表
      memberList: [],
      // 会员列表
      giftCard: {},
      // 礼品卡信息
      faceValues: [],
      formRules: {
        crmNum: [{
          validator: function validator(_rule, value, callback) {
            if (_this.form.chargeType === 'principal' && !value) {
              callback(new Error('本金类型必须输入CRM流水号'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      form: {
        giftCardFnId: '',
        userFnIds: [],
        taskName: '',
        cardValue: null,
        assignNum: 1,
        chargeType: 'principal',
        crmNum: '',
        coverImage: ''
      }
    };
  },
  created: function created() {
    this.form.giftCardFnId = this.fnId;
    this.queryMemberLabelCombo();
    this.loadGiftCard();
  },
  methods: {
    handleToGiftCardAssignTaskTable: function handleToGiftCardAssignTaskTable() {
      this.$emit('toGiftCardAssignTaskTable');
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          (0, _gift_card.createGiftCardAssign)(_this2.form).then(function () {
            _this2.$message.success('提交成功');
            _this2.handleToGiftCardAssignTaskTable();
          });
        }
      });
    },
    reset: function reset() {},
    selectCoverImage: function selectCoverImage(coverImage) {
      this.form.coverImage = coverImage;
    },
    loadGiftCard: function loadGiftCard() {
      var _this3 = this;
      this.loading = true;
      (0, _gift_card.getGiftCard)(this.fnId).then(function (response) {
        var data = response.data;
        if (data) {
          _this3.giftCard = data.giftCard || {};
          _this3.faceValues = data.faceValues || [];
        }
        _this3.loading = false;
      }, function () {
        _this3.loading = false;
      });
    },
    queryMemberLabelCombo: function queryMemberLabelCombo() {
      var _this4 = this;
      (0, _common.getMemberLabelCombo)().then(function (response) {
        _this4.memberLabels = response.data;
      });
    },
    queryMemberSearchCombo: function queryMemberSearchCombo() {
      var _this5 = this;
      var query = {
        memberLabelId: this.memberLabel,
        keywords: this.keywords
      };
      (0, _common.getMemberSearchCombo)(query).then(function (response) {
        _this5.memberList = response.data || [];
      });
    }
  }
};